import * as loglevel from 'loglevel'
import { Deferred } from './utils'

export interface QueuedMessage {
  formattedMessage: string
  deferred: Deferred<void>
  messageAppName?: string
}

export type LogMethods = 'trace' | 'debug' | 'info' | 'warn'

export interface JsonFormatParams {
  message: Record<string, any> | string
  methodName: string
  logLevel: loglevel.LogLevelNumbers
  loggerName: string
}

export interface LoglevelPluginServerOptions {
  url?: string
  reqHeaders?: Record<string, string>
  callOriginal?: boolean
  level?: loglevel.LogLevelNumbers
  format?: (formatParams: JsonFormatParams) => string
}

export enum LogMissingParamPlaceholders {
  AccessToken = 'ACCESS_TOKEN_MISSING',
  IdToken = 'ID_TOKEN_MISSING',
  ApplicationSource = 'APPLICATION_SOURCE_MISSING',
  CrmContactId = 'CRM_CONTACT_ID_MISSING',
  CrmAccountGuid = 'CRM_ACCOUNT_GUID',
  Nonce = 'NONCE_MISSING',
  tmxToken = 'TMX_TOKEN_MISSING',
  BrowserName = 'BROWSER_NAME_MISSING',
  BrowserVersion = 'BROWSER_VERSION_MISSING',
  OsName = 'OPERATING_SYSTEM_NAME_MISSING',
  OsVersion = 'OPERATING_SYSTEM_VERSION_MISSING',
  Device = 'DEVICE_MODEL_MISSING',
  DeviceType = 'DEVICE_TYPE_MISSING',
  DeviceVendor = 'DEVICE_VENDOR_MISSING'
}

export type PartnerName = string | null | undefined

export interface LogMessage {
  partnerName: PartnerName
  applicationSource: string
  nonce: string
  timestamp: number
  localTimeString: string
  message: string
  crmContactId?: string
  navigatorUserAgent: string
  threatMetrixToken: string
  crmAccountGuid: string
  navigatorAppVersion: string
  navigatorAppName: string
  navigatorCookiesEnabled: boolean
  navigatorLocale: string
  navigatorScreenSize: string
  bundleVersion: string
  browserName: string
  browserVersion: string
  osVersion: string
  osName: string
  deviceModel: string
  deviceVendor: string
  deviceType: string
}

export interface GenericPromiseRejectionErrorMessage {
  message: string
}

export interface LogRawData {
  message: string
  appName?: string
  access_token?: AccessToken
  id_token?: IdToken
  otherParams?: Record<string, any>
}

export interface LogFormattedData {
  isError: boolean
  message: LogMessage
  appName?: string
  access_token?: AccessToken
  id_token?: IdToken
  logger?: string
  logLevel?: number
  logMethod?: string
}

export interface AccessToken {
  ApplicationSource?: string
  CrmContactId?: string
}

export interface IdToken {
  nonce?: string
}

export const defaultAppName = 'imali-app'
